import { isEqual } from 'lodash'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import ImagePickerItem, { ImagePickerSourceItem } from 'entities/image_picker_item'
import ImageSource from 'entities/image_source'

const DefaultImageSelector = ({ imageSources, order, pickerItem, onChangePickerItem }) => {
  if (pickerItem.url && !pickerItem.isDefaultImage) {
    return null
  }

  const handleChangeItem = source => {
    const newPickerItem = new ImagePickerSourceItem(source)
    onChangePickerItem(newPickerItem)
  }

  return (
    <div className="form-group">
      <div className="form-label">{I18n.t('components.image_picker_default_image_selector.label')}</div>
      <div className="form-group-images">
        {imageSources.map(source => {
          const checked = isEqual(source.url, pickerItem.url)
          const classname = classnames('attach-media-group', {
            'is-active': checked
          })
          const suffix = order === null ? '' : `_${order}`
          const inputHtmlFor = `radio-option-${source.source}${suffix}`

          return (
            <label key={inputHtmlFor} className={classname} htmlFor={inputHtmlFor}>
              <input
                type="radio"
                className="attach-media-radio"
                id={inputHtmlFor}
                onChange={() => handleChangeItem(source)}
                checked={checked}
              />
              <div className="attach-media-image" style={{ backgroundImage: `url(${source.url})` }} />
            </label>
          )
        })}
      </div>
    </div>
  )
}

DefaultImageSelector.propTypes = {
  imageSources: PropTypes.arrayOf(PropTypes.instanceOf(ImageSource)).isRequired,
  order: PropTypes.number,
  pickerItem: PropTypes.instanceOf(ImagePickerItem).isRequired,
  onChangePickerItem: PropTypes.func.isRequired
}

DefaultImageSelector.defaultProps = {
  order: null
}

export default DefaultImageSelector
